import { request } from '@/services/request';
import type { ReplyData, ReqParams } from '@/pages/api/license/getLicenseList';

export function getLicenseList(params: ReqParams): Promise<ReplyData> {
  return request({
    method: 'post',
    url: '/api/license/getLicenseList',
    data: params,
  }).then((res) => res.data);
}
